import { gql, useMutation } from '@apollo/client';

import { GET_CONSULTANT_NUMBERS } from 'src/hooks/consultant-numbers/get-consultant-numbers.hook';

import { GET_DATEV_NUMBER_BY_ID } from './get-datev-number-by-id.hook';
import { GET_DATEV_NUMBERS } from './get-datev-numbers.hook';

export const CREATE_DATEV_NUMBER = gql`
  mutation createDatevNumber($payload: CreateDatevNumberInput!) {
    createDatevNumber(payload: $payload) {
      _id
    }
  }
`;

export const useCreateDatevNumber = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createDatevNumber] = useMutation(CREATE_DATEV_NUMBER, {
    onCompleted: onSuccess,
    refetchQueries: [GET_DATEV_NUMBER_BY_ID, GET_DATEV_NUMBERS, GET_CONSULTANT_NUMBERS],
  });

  return createDatevNumber;
};
